module.exports = __webpack_public_path__ + "static/media/Fortress5.af94ee3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Fortress5.jpg
// module id = 1024
// module chunks = 0